/// <reference path="../_all.ts" />

module navigation {

  export function responsiveImage(): ng.IDirective {

    return {
      restrict: 'A',
      scope: {
        imgSrc: '='
      },
      link: function (scope: IResponsiveImageScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        element.addClass("responsiveimg");
        scope.$watch('imgSrc', function(value) {
          if (value) {
            element.css({
                'background-image': 'url(' + value +')'
            });
          } else {
            element.css({
                'background-image': 'none'
            });
          }
        });
      }
    }
  }

}